import { Box } from '@mui/material';

import { formatAsFloat } from '@work4all/utils';

export type ITimeCellProps = {
  value: string;
  column: {
    cellParams: {
      convertTo?: 'days' | 'hours';
    };
  };
};

const WORK_HOURS = 8;

export const TimeCell = (props: ITimeCellProps) => {
  const {
    value,
    column: { cellParams },
  } = props;

  let result = parseFloat(value);

  if (cellParams && cellParams.convertTo === 'hours') {
    result *= WORK_HOURS;
  }

  return (
    result > 0 && (
      <Box textAlign="right">
        {formatAsFloat(result, {
          maximumFractionDigits: 2,
          minimumFractionDigits: 0,
        })}
      </Box>
    )
  );
};
